const aux = (props) => props.children;

export default aux;


// WEBPACK FOOTER //
// ./src/Hoc/Aux/Aux.js